<template>
    <v-container fluid fill-height>
        <v-flex xs12 sm8 md8 lg8>
          <v-card class="elevation-2">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Tracking
                  </th>
                  <th class="text-left">
                    Clocked In
                  </th>
                  <th class="text-right">
                    Duration (hr/min)
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="track in timeSheet"
                    :key="track.id"
                    @click="openTracker (track)"
                >
                  <td>{{ track.name }}</td>
                    <td>
                      <span v-if="track.clockedIn && !track.clockedOut">{{ momentTime(track.clockedIn.time) }}</span>
                      <div v-if="track.clockedOut">Clocked out: </div>
                    </td>
                    <td class="text-right">
                      <p v-if="track.clockedIn && !track.clockedOut">{{ elapsedTime(convertToTimestamp(track.clockedIn)) }}</p>
                      <span v-if="track.clockedOut">{{totalDuration(track)}}</span>
                    </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-card-actions>
              <v-btn small block text outlined
                     @click="openTracker({type:'addNew'})">
                Add tracker</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      <v-dialog v-model="editTimeDialog"
                persistent
                max-width="500"
      >
        <v-card v-if="selectedTrackerTime">
          <v-card-title class="text-h6">
            Edit {{selectedTrackerTime.type}}
          </v-card-title>
          <v-card-text>
            <v-time-picker
                color="blue"
                v-model="selectedTrackerTime.time"
                ampm-in-title
                scrollable
            ></v-time-picker>
            <v-date-picker
                color="blue"
                v-model="selectedTrackerTime.date"
                full-width
                class="mt-4"
            ></v-date-picker>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="editTimeDialog = false">cancel</v-btn>
            <v-btn @click="updateClockTime" class="blue white--text">
              save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="removeTrackerDialog"
                persistent
                max-width="250"
      >
        <v-card v-if="selectedTracker">
          <v-card-title class="text-h6">
            Delete forever?
          </v-card-title>
          <v-card-actions>
            <v-btn @click="removeTrackerDialog = false">cancel</v-btn>
            <v-btn @click="removeSelectedTracker" class="red white--text">
                Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="trackerDialog"
                persistent
                max-width="500"
      >
        <v-card v-if="selectedTracker">
          <v-card-title class="text-h5">
            {{selectedTracker.name}}
          </v-card-title>
          <v-card-text>
<!--            tracker name-->
            <v-text-field
                v-model="selectedTracker.name"
                label="Label"
                placeholder="Enter tracker name"
                prepend-icon="label"
                clearable
            >
            </v-text-field>
<!--            if not clocked in or out show current time-->
             <v-list>
               <v-list-item>
                 <v-list-item-action>
                 </v-list-item-action>
                 <v-list-item-title>
                   Time Now:
                   <h2 class="heading">
                     {{ formattedTime }}
                   </h2>
                 </v-list-item-title>
               </v-list-item>

<!--               if clocked in -->
<!--               display clocked in time stamp-->
               <v-list-item three-line v-if="selectedTracker.clockedIn">
                 <v-list-item-action>
                   <v-icon>schedule</v-icon>
                 </v-list-item-action>
                 <v-list-item-content>
                   <v-list-item-title>Clocked in:</v-list-item-title>
                   <v-list-item-subtitle>
                     {{  momentTime(selectedTracker.clockedIn.time) }}
                   </v-list-item-subtitle>
                   <v-list-item-subtitle>
                     {{  momentDate(selectedTracker.clockedIn.date) }}
                   </v-list-item-subtitle>
                 </v-list-item-content>
                 <v-list-item-icon @click="openTimeEditor(
                     {
                     time: selectedTracker.clockedIn.time,
                     type: 'Clock in',
                     date: selectedTracker.clockedIn.date
                     })">
                   <v-icon>edit</v-icon>
                 </v-list-item-icon>
               </v-list-item>
               <!--                if clocked out then display-->
               <!--                 clock out time with edit button -->
               <v-list-item three-line v-if="selectedTracker.clockedOut">
                 <v-list-item-action>
                   <v-icon>schedule</v-icon>
                 </v-list-item-action>
                 <v-list-item-content>
                   <v-list-item-title>Clocked out:</v-list-item-title>
                   <v-list-item-subtitle>
                     {{ momentTime(selectedTracker.clockedOut.time) }}
                   </v-list-item-subtitle>
                   <v-list-item-subtitle>
                     {{ momentDate(selectedTracker.clockedOut.date) }}
                   </v-list-item-subtitle>
                 </v-list-item-content>
                 <v-list-item-icon @click="openTimeEditor(
                     {
                     time: selectedTracker.clockedOut.time,
                     type: 'Clock out',
                     date: selectedTracker.clockedOut.date
                     })">
                   <v-icon>edit</v-icon>
                 </v-list-item-icon>
               </v-list-item>
             </v-list>
            <!--if new clock then display-->
<!--            clock in button-->
            <div class="mt-4" v-if="!selectedTracker.clockedIn">
              <v-btn @click="clockIn" block outlined text>
                Clock in
              </v-btn>
              <!--              clock in with notification-->
              <v-btn v-if="type === 'clientTimesheet'" @click="clockInAndNotify" block outlined class="mt-2" text>
                Clock in & Notify
                <v-icon>send</v-icon>
              </v-btn>

              <v-btn v-if="type === 'crewTimesheet'" @click="openCrewNotificationDialog('clockIn')" block outlined class="mt-2" text>
                Clock in & Notify
                <v-icon>send</v-icon>
              </v-btn>

            </div>

<!--             if clocked in then display
                      clock out button-->
<!--                  clock out with notification button-->
            <div class="mt-4" v-if="selectedTracker.clockedIn && !selectedTracker.clockedOut">
              <v-btn @click="clockOut" block outlined text>
                Clock out
              </v-btn>
              <!--              clock out with notification-->

              <v-btn v-if="type === 'clientTimesheet'" @click="clockOutAndNotify" block outlined class="mt-2" text>
                Clock out & Notify
                <v-icon>send</v-icon>
              </v-btn>

              <v-btn v-if="type === 'crewTimesheet'" @click="openCrewNotificationDialog('clockOut')" block outlined class="mt-2" text>
                Clock out & Notify
                <v-icon>send</v-icon>
              </v-btn>
            </div>

<!--          if clocked out then display delete button-->
            <div class="mt-4" v-if="selectedTracker.clockedOut">
              <v-divider></v-divider>
                <v-card-subtitle>
                  Total Time (hr/min):
                </v-card-subtitle>
              <v-card-title class="blue--text">
                <v-icon>timer</v-icon> {{totalDuration(selectedTracker)}}
              </v-card-title>
              <v-textarea
                  class="mt-4"
                  v-model="selectedTracker.note"
                  label="Note"
                  persistent-hint
                  prepend-icon="add"
              ></v-textarea>
            </div>
            <v-btn v-if="!selectedTracker.type" outlned class="mt-6 red--text" @click="removeTrackerDialog = true" block outlined text>
              delete
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                text
                @click="resetSelectedTracker"
            >
              cancel
            </v-btn>
            <v-btn
                color="green darken-1"
                text
                @click="saveTracker"
                v-if="!selectedTracker.type"
            >
              Done
            </v-btn>
            <v-btn @click="saveTrackerNameOnly"  v-else>
              Save tracker
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="crewNotificationDialog"
                persistent
                max-width="500"
      >
        <v-card v-if="selectedTracker">
          <v-card-title class="text-h5">
            Notify:
          </v-card-title>
          <v-card-text v-if="fulfillmentData">

            <v-textarea
                clearable
                label="Message"
                placeholder="message body ..."
                v-model="crewMsg"
            ></v-textarea>
          </v-card-text>
          <v-card-text>

            <!--            if not clocked in or out show current time-->
            <v-list v-for="crew in fulfillmentData.activeContacts" :key="crew.contactId">
              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                      v-model="crew.notify"
                     color="blue"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-title>
                  <h2 class="heading">
                    {{ crew.name }}
                  </h2>
                </v-list-item-title>
              </v-list-item>
            </v-list>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                text
                @click="crewNotificationDialog = false"
            >
              cancel
            </v-btn>
            <v-btn
                color="green darken-1"
                text
                @click="notifyCrew"
            >
              Send
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>
<script>
import moment from "moment";
import {v1 as uuidv1} from "uuid";
import {doc, updateDoc} from "firebase/firestore";

export default {
  props: ['fulfillmentData', 'type'],
  data: () => ({
    trackerDialog: false,
    currentTime: new Date(),
    timeSheet: [],
    selectedTracker: null,
    removeTrackerDialog: false,
    editTimeDialog: false,
    selectedTrackerTime: null,
    crewNotificationDialog: false,
    sendingCrewClockInNotification: false,
    crewMsg: ''
  }),
  created () {
    // console.log(this.type)
    // console.log(this.fulfillmentData)
    if (this.type === 'crewTimesheet' && this.fulfillmentData) {
      if (this.fulfillmentData.crewTimesheet) {
        this.timeSheet = this.fulfillmentData.crewTimesheet
      }
    }
    if (this.type === 'clientTimesheet' && this.fulfillmentData) {
      if (this.fulfillmentData.clientTimesheet) {
        this.timeSheet = this.fulfillmentData.clientTimesheet
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    // timeNow () {
    //   return moment(Date.now()).format('hh:mm A')
    // },
    momentTime () {
      return (time) => {
        return moment(time, "HH:mm").format('hh:mm A')
      }
    },
    momentDate() {
      return (date) => {
        return moment(date).format('dddd, LL')
      }
    },
    formattedTime() {
      let hours = this.currentTime.getHours();
      const minutes = this.currentTime.getMinutes().toString().padStart(2, "0");
      const seconds = this.currentTime.getSeconds().toString().padStart(2, "0");
      const amPm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12 || 12; // Convert to 12-hour format

      return `${hours}:${minutes}:${seconds} ${amPm}`;
    },


  },
  mounted() {
    this.timer = setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    openCrewNotificationDialog (clockType) {
      if (clockType === 'clockIn') {
        this.crewMsg = 'Clocked in at ' + moment().format('hh:mm A')
        this.sendingCrewClockInNotification = true
      }
      if (clockType === 'clockOut') {
        let now = {
          time: moment().format('HH:mm'),
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000))
              .toISOString().substr(0, 10)
        }
        let stagedTracker = {...this.selectedTracker}
        stagedTracker.clockedOut = now
        let totalTime = this.totalDuration(stagedTracker)

        this.crewMsg = 'Clocked out at ' + moment().format('HH:mm')
            + '. ' + 'Total time: ' + totalTime + ' (hr/min)'
        this.sendingCrewClockInNotification = false
      }
      this.crewNotificationDialog = true
    },
    notifyCrew() {
      if (this.sendingCrewClockInNotification) {
        return this.clockInAndNotify()
      } else {
        return this.clockOutAndNotify()
      }
    },
    convertToTimestamp(entry) {
      const dateTimeString = `${entry.date} ${entry.time}`; // "2025-02-23 12:00"
      return new Date(dateTimeString).getTime(); // Convert to Unix timestamp
    },
    totalDuration(recordedTimestamps) {
      // let recordedTimestampUnix =
      let clockedIn = this.convertToTimestamp(recordedTimestamps.clockedIn)
      let clockedOut = this.convertToTimestamp(recordedTimestamps.clockedOut)
      let diffInSeconds = Math.floor((clockedOut - clockedIn) / 1000);

      const hours = Math.floor(diffInSeconds / 3600);
      diffInSeconds %= 3600;
      const minutes = Math.floor(diffInSeconds / 60);


      return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    },
    elapsedTime(recordedTimestamp) {
      // let recordedTimestampUnix =
      const now = Date.now();
      let diffInSeconds = Math.floor((now - recordedTimestamp) / 1000);

      const hours = Math.floor(diffInSeconds / 3600);
      diffInSeconds %= 3600;
      const minutes = Math.floor(diffInSeconds / 60);

      return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    },

    openTracker (tracker) {
      console.log(tracker)
      if (tracker.type === 'addNew') {
        this.selectedTracker = {
          type: 'addNew',
          name: 'Tracker',
          id: uuidv1(),
          created: Date.now()
        }
      } else {
        this.selectedTracker = {...tracker}
      }
      this.trackerDialog = true
    },
    saveTrackerNameOnly () {
      let obj = {...this.selectedTracker}
      obj.type = null
      // console.log(obj)
      this.timeSheet.push(obj)
      this.updateFulfillment()
      this.resetSelectedTracker ()
    },
    clockOutAndNotify () {
      let now = {
        time: moment().format('HH:mm'),
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000))
            .toISOString().substr(0, 10)
      }
      let stagedTracker = {...this.selectedTracker}
      stagedTracker.clockedOut = now
      let totalTime = this.totalDuration(stagedTracker)
      if (this.type === 'crewTimesheet' && this.fulfillmentData) {
        this.clockOut()
        let msg = 'Clocked out at ' + moment().format('HH:mm')
            + '. ' + 'Total time: ' + totalTime + ' (hr/min)'
        let crew = []
        this.fulfillmentData.activeContacts.forEach(contact => {
          if (contact.notify) {
            crew.push(contact)
          }
        })
        this.crewNotificationDialog = false
        return this.$emit('crewNotification', {text: msg, notifyCrew: crew})
      }
      if (this.type === 'clientTimesheet' && this.fulfillmentData) {
        this.clockOut()

        let msg = 'Clocked out at ' + moment().format('hh:mm A')
            + '. ' + 'Total time: ' + totalTime + ' (hr/min)'
        return this.$emit('clientNotification', msg)
      }

    },
    clockInAndNotify () {
      if (this.type === 'crewTimesheet' && this.fulfillmentData) {
        this.clockIn()
        let msg = 'Clocked in at ' + moment().format('hh:mm A')
        let crew = []
        this.fulfillmentData.activeContacts.forEach(contact => {
          if (contact.notify) {
            crew.push(contact)
          }
        })
        this.crewNotificationDialog = false
        return this.$emit('crewNotification', {text: msg, notifyCrew: crew})
      }
      if (this.type === 'clientTimesheet' && this.fulfillmentData) {
        this.clockIn()
        let msg = 'Clocked in at ' + moment().format('hh:mm A')
        return this.$emit('clientNotification', msg)
      }

    },
    clockIn () {
      this.selectedTracker.type = null
      this.selectedTracker.clockedIn = Date.now()
      let clockObj = {
        ...this.selectedTracker,
        id: uuidv1()
      }
      clockObj.created = Date.now()
      clockObj.clockedIn = {
        time: moment().format('HH:mm'),
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000))
            .toISOString().substr(0, 10)
      }
      if (clockObj.name === '') {
        clockObj.name = 'Tracking'
      }
      // console.log('Clocked In')
      // console.log(clockObj)
      this.timeSheet.push(clockObj)
      this.updateFulfillment()
      this.resetSelectedTracker ()
    },
    clockOut () {
      // console.log(this.selectedTracker)
      let updatedTimeSheet = this.timeSheet
      this.timeSheet = []
      let timeSheetObj = updatedTimeSheet.find(obj => {
        return obj.id === this.selectedTracker.id
      })
      // console.log(timeSheetObj)

      let indexOfSelectedTracker = updatedTimeSheet.indexOf(timeSheetObj)
      // console.log(indexOfSelectedTracker)
      let now = {
        time: moment().format('HH:mm'),
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000))
            .toISOString().substr(0, 10)
      }
      // console.log('clockedOut')
      // console.log(updatedTimeSheet[indexOfSelectedTracker])
      updatedTimeSheet[indexOfSelectedTracker].clockedOut = now
      this.selectedTracker = updatedTimeSheet[indexOfSelectedTracker]
      this.timeSheet = updatedTimeSheet
      this.updateFulfillment()
      // console.log(this.timeSheet)
      // let diffInSeconds = Math.floor((now - recordedTimestamp) / 1000);
      // this.resetSelectedTracker ()

    },
    openTimeEditor (obj) {
      // let formattedTime =  moment(obj.time, 'hh:mm A').format( "HH:mm")
      this.selectedTrackerTime = {...obj}
      this.editTimeDialog = true
      // console.log(obj)
    },
    updateClockTime () {
      let updatedTimeObj = this.selectedTrackerTime
      // let unixFormat =  moment(updatedTimeObj.time, "HH:mm").format( "HH:mm")
      if (updatedTimeObj.type === 'Clock in') {
        this.selectedTracker.clockedIn.time = updatedTimeObj.time
        this.selectedTracker.clockedIn.date = updatedTimeObj.date
        // console.log('clockInTime')
        this.updateFulfillment()
        this.editTimeDialog = false
      }
      if (updatedTimeObj.type === 'Clock out') {
        this.selectedTracker.clockedOut.time = updatedTimeObj.time
        this.selectedTracker.clockedOut.date = updatedTimeObj.date
        // console.log('clockInTime')
        this.editTimeDialog = false
        // console.log('clockOutTime')
        this.updateFulfillment()
      }
    },
    removeSelectedTracker () {
      let updatedTimeSheet = this.timeSheet
      this.timeSheet = []
      let timeSheetObj = updatedTimeSheet.find(obj => {
        return obj.id === this.selectedTracker.id
      })
      // console.log(timeSheetObj)

      let indexOfSelectedTracker = updatedTimeSheet.indexOf(timeSheetObj)
      // console.log(indexOfSelectedTracker)
      updatedTimeSheet.splice(indexOfSelectedTracker, 1)
      this.timeSheet = updatedTimeSheet
      this.updateFulfillment()
      this.resetSelectedTracker ()
    },
    updateFulfillment() {
      let db = this.$store.state.db
      let id = this.fulfillmentData.orderData.id
      let fulfillmentRef = doc(db, 'users', this.user.uid, 'fulfillment', id)

      if (this.type === 'crewTimesheet') {
        this.fulfillmentData.crewTimesheet = this.timeSheet
      }
      if (this.type === 'clientTimesheet') {
        this.fulfillmentData.clientTimesheet = this.timeSheet
      }
      updateDoc(fulfillmentRef, this.fulfillmentData)
          .catch(err => {
            this.$store.dispatch('setError', err)
          })
    },
    resetSelectedTracker () {
      this.trackerDialog = false
      this.removeTrackerDialog = false
      this.editTimeDialog = false
      this.selectedTracker = {
        id: 1,
        name: ''
      }
    },
    saveTracker () {
      this.trackerDialog = false
      this.updateFulfillment()
      this.resetSelectedTracker ()
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

